import actions from './actions'
import searchConfigOperations from '../searchConfig/operations'
import { logGaNonInteractionEvent } from 'common/utils/analytics'
import apiManager from 'tickets/utils/apiManager'
import {
  TAB_ORDER_PREFERENCES,
  NO_RESULTS_MODE,
} from 'tickets/utils/constants'
import routerOperations from 'tickets/redux/modules/router/operations'
import {
  getCurrentModeId,
  getSearchOutboundDateTime,
  getSearchInboundDateTime,
} from 'tickets/redux/modules/router/selectors'

import {
  getDestinationGooglePlaceId,
  getDestinationLongName,
  getDestinationShortName,
  getOriginGooglePlaceId,
  getOriginLongName,
  getOriginShortName,
} from 'tickets/redux/modules/location/selectors'

const configReceived = actions.configReceived
const configFailed = actions.configFailed

let lastFetchAvailableModesRequestTimestamp
const fetchAvailableModes = (origin, destination, requestTimestamp) => (dispatch, getState) => {
  const state = getState()
  lastFetchAvailableModesRequestTimestamp = requestTimestamp
  const modeIdPromise = new Promise(
    (resolve, reject) => {
      apiManager.schedulesConfig(origin, destination)
        .then((response) => {
          if (requestTimestamp === lastFetchAvailableModesRequestTimestamp) {
            const extraParms = {
              outboundDateTime: getSearchOutboundDateTime(state),
              inboundDateTime: getSearchInboundDateTime(state),
              originGooglePlaceId: getOriginGooglePlaceId(state),
              destinationGooglePlaceId: getDestinationGooglePlaceId(state),
              originLongName: getOriginLongName(state),
              destinationLongName: getDestinationLongName(state),
            }
            dispatch(configReceived(response, extraParms))
            dispatch(setDefaultModeID(response))
            logGaNonInteractionEvent(
              'Tickets', 'API:Config', 'Success'
            )
          }

          resolve()
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log('error', error)
          /* eslint-enable no-console */

          dispatch(searchConfigOperations.configFailed())

          reject()

          logGaNonInteractionEvent(
            'Tickets', 'API:Config', `Error:${error}`
          )
        })
    }
  )
  return modeIdPromise
}

const setDefaultModeID = (payload) => (dispatch, getState) => {
  const state = getState()
  const oldModeId = getCurrentModeId(state)
  const kinds = payload.data.transitKinds.map(kind =>
    kind.transitKind)

  const availableModesOrdered =
    kinds.sort((a, b) => {
      const aOrderScore = TAB_ORDER_PREFERENCES[a] || 0
      const bOrderScore = TAB_ORDER_PREFERENCES[b] || 0
      return aOrderScore < bOrderScore ? 1 : -1
    }
  )

  const isCurrentModeAvailable = availableModesOrdered.includes(oldModeId)
  let currentModeId = oldModeId
  if (kinds.length == 0) {
    currentModeId = NO_RESULTS_MODE
  } else if (!isCurrentModeAvailable) {
    if (oldModeId !== null) {
      // the user entered using a mode=?? which is not available on startup
      logGaNonInteractionEvent(
        'FailedHandover', `ConfigFail:${oldModeId}`,
        `${getOriginShortName(state)}/${getDestinationShortName(state)}`
      )
    }
    currentModeId = availableModesOrdered[0]
  }

  dispatch(routerOperations.updateModeId(currentModeId, true))
}

export default {
  configReceived,
  configFailed,
  fetchAvailableModes,
}
